module.exports = __webpack_public_path__ + "static/img/m3_t1.51ccfd09.jpg";